















































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import CompanyPlace from "@/models/CompanyPlace";
import VGooglePlaceAutocomplete from "@/components/VGooglePlaceAutocomplete.vue";
import { currentCompanyStore } from "@/store/typed";

@Component({
  components: {
    VModal,
    VGooglePlaceAutocomplete,
  },
})
export default class PoiModal extends Vue {
  @Prop({ default: "" }) readonly title?: string;
  @Prop({ required: true }) companyPlace?: CompanyPlace;

  @Ref() googlePlaceAutocomplete!: VGooglePlaceAutocomplete;
  @Ref() modal!: VModal;

  private formError = false;
  private errorMessage = "";

  mounted() {
    this.formError = false;
    this.errorMessage = "";
  }

  get shouldBeCorrected() {
    return (
      this.companyPlace?.status !== "ready" &&
      this.companyPlace?.source === "google_places"
    );
  }

  protected onDelete() {
    this.$emit("delete", this.companyPlace);
    this.modal.hide();
  }

  protected onSave() {
    const placeId = this.googlePlaceAutocomplete.getPlaceId();
    if (!placeId?.length) {
      this.formError = true;
      this.errorMessage = "Indirizzo non valido";
      return;
    }

    const candidate = currentCompanyStore.companyPlaces.find((place) => {
      return place.sourceId === placeId && place.id !== this.companyPlace?.id;
    });
    if (!candidate && this.companyPlace) {
      this.companyPlace.fullAddress =
        this.googlePlaceAutocomplete.getPlaceName();
      this.companyPlace.position = this.googlePlaceAutocomplete.getPlacePoint();
      this.companyPlace.sourceId = this.googlePlaceAutocomplete.getPlaceId();
      this.companyPlace.source = "google_places";
      this.companyPlace.status = "ready";
      this.companyPlace.highlighted = true;
      this.$emit("save", this.companyPlace);
      this.modal.hide();
    }
  }

  protected onHidden() {
    //this.modal.hide();
  }

  show() {
    this.formError = false;
    this.errorMessage = "";
    this.modal.show();
  }
}
